import { RING_API } from '../protocol/constants.js';
import { RtcError, } from '../protocol/types.js';
import { errorFromResponse, networkError } from '../token/httpErrors.js';
const unwrapData = (value) => {
    if (value && typeof value === 'object' && 'data' in value) {
        return value.data;
    }
    throw new RtcError('unavailable', 'Ring API returned an unexpected body');
};
export class RingClient {
    constructor(options) {
        this.options = options;
        this.baseUrl = options.baseUrl.replace(/\/+$/, '');
    }
    async start(request) {
        const response = await this.send(`${this.baseUrl}${RING_API.collectionPath}`, 'POST', JSON.stringify(request), 'ring.start');
        if (!response.ok) {
            throw await errorFromResponse(response, 'ring.start');
        }
        return unwrapData(await response.json());
    }
    async findByNotification(roomId, notificationEventId) {
        const query = `notificationEventId=${encodeURIComponent(notificationEventId)}&roomId=${encodeURIComponent(roomId)}`;
        const response = await this.send(`${this.baseUrl}${RING_API.collectionPath}?${query}`, 'GET', undefined, 'ring.lookup');
        if (!response.ok) {
            throw await errorFromResponse(response, 'ring.lookup');
        }
        return unwrapData(await response.json());
    }
    async targets(roomId) {
        const url = `${this.baseUrl}${RING_API.targetsPath}?roomId=${encodeURIComponent(roomId)}`;
        const response = await this.send(url, 'GET', undefined, 'ring.targets');
        if (!response.ok) {
            throw await errorFromResponse(response, 'ring.targets');
        }
        return unwrapData(await response.json());
    }
    async activeInvites() {
        const response = await this.send(`${this.baseUrl}${RING_API.activeInvitesPath}`, 'GET', undefined, 'ring.active_invites');
        if (!response.ok) {
            throw await errorFromResponse(response, 'ring.active_invites');
        }
        return unwrapData(await response.json());
    }
    async decline(ringId) {
        const response = await this.send(`${this.baseUrl}${RING_API.collectionPath}/${encodeURIComponent(ringId)}/targets/me`, 'PATCH', JSON.stringify({ status: 'DECLINED' }), 'ring.decline');
        if (!response.ok) {
            throw await errorFromResponse(response, 'ring.decline');
        }
    }
    async send(url, method, body, context) {
        const authorization = await this.options.authorization();
        try {
            return await this.options.fetch(url, {
                method,
                headers: {
                    ...(authorization ? { Authorization: authorization } : {}),
                    ...(body ? { 'Content-Type': 'application/json' } : {}),
                },
                body,
            });
        }
        catch (error) {
            throw networkError(context, error);
        }
    }
}
export const ringModeForMemberCount = (joinedMembers, threshold) => joinedMembers <= threshold ? 'ring' : 'notification';
